import { BookOpen } from "lucide-react";
import useTranslation from "../client/hooks/useTranslation";
import { Button } from "../client/components/ui/button";
import { Card } from "../client/components/ui/card";

export default function PlaybookEmptyState({ onCreate }: { onCreate: () => void }) {
  const t = useTranslation();

  return (
    <Card className="p-8 flex flex-col items-center gap-3 text-center">
      <BookOpen className="h-8 w-8 text-primary" />
      <span className="font-medium">{t.playbook.emptyTitle}</span>
      <p className="text-sm text-muted-foreground max-w-md">{t.playbook.emptyDescription}</p>
      <Button onClick={onCreate}>{t.playbook.emptyCta}</Button>
    </Card>
  );
}
